export const BUTTON_CAPTION_ANSWER = `Ответить`;

export const BUTTON_CAPTION_REMOVE = `Удалить`;

export const BUTTON_CAPTION_REPORT = `Жалоба`;
